import React, { useEffect, useState } from 'react';
import configData from "../appconfig/config.json";
import { Form } from '@progress/kendo-react-form';
import { Field } from '@progress/kendo-react-form';
import { FormReviewLabel } from '../core/customComponents';
import { tovalidateExpdate } from '../core/validationRules';
import FormContainer from './FormContainer';
import { Button } from '@progress/kendo-react-buttons';
import { Checkbox } from "@progress/kendo-react-inputs";
import helper from '../data/Helper';

import { decryptAesText } from "../core/cryptoHelper";
import Loading from './Loading';

import { useHistory } from "react-router-dom";

import { v4 as uuidv4 } from 'uuid';
import useCountDown from "react-countdown-hook";
import {
    Notification,
    NotificationGroup,
} from "@progress/kendo-react-notification";
import toFetchIDValue from '../data/IdTypeCheck';

var CryptoJS = require("crypto-js");
let key = CryptoJS.enc.Utf8.parse(configData.CRYPT);
let iv = CryptoJS.enc.Utf8.parse(configData.CRYPT);

configData.RefferenceNo = localStorage.getItem('Ref');
let LBL_TNC = configData.TERMS_CONDITIONS;
let LBL_TNCLAST = configData.TERMS_CONDITIONS1;
let LBL_TNCWORD = configData.TERMS_CONDITIONS2;

let LBL_SUBMITTED_TEXT = configData.LBL_SUBMITTED_TEXT;
let hideContentForSubmit = false;
let responsesetitesms = 1;
let cmpnt = FormReviewLabel;

let url = configData.URL_TERMS;
let url1 = configData.URL_TERMS1;
let urlTerms = configData.URL_TERMS_203_209;
let urlGarmin = configData.URL_GarminWatch;
let urlIngersoll = configData.URL_Ingersoll;
let urlnew = configData.URL_TERMSNEW;

let TF1FRM1;
let CCCANO1;
let Pricing1;
let Trnsferto1;
let NameacntHolder1;
let CCAnCNTNO1;
let AMNT1;
let SourceCodehandle;

const ReviewDetails = (props) => {
    let history = useHistory();
    // TODO
    const [response, setResponce] = useState(null);

    const [OTPValue, setOTPValue] = useState("");
    const [OtpconfirmDisabled, setOtpconfirmDisabled] = useState(false);
    const [toshowResend, settoshowResend] = useState(false);
    const [isLoading, setIsLoading] = useState(false); //to show api call
    const [checkedTerms, setcheckedTerms] = useState(false); //to show api call
    const [disabltoRequestotp, setdisabltoRequestotp] = useState(true); //to show api call
    const [ALLOTPgenration, setALLOTPgenration] = useState("");



    const [count3TimeToExist, setcount3TimeToExist] = useState(0);
    const initialTime = 120 * 1000; // initial time in milliseconds, defaults to 60000
    const interval = 1000; // interval to change remaining time amount, defaults to 1000
    const [timeLeft, { start, pause, resume, reset }] = useCountDown(
        initialTime,
        interval
    );

    const [currentDateTime, setcurrentDateTime] = useState(); //to show api call


    const [trimMobile, settrimMobile] = useState("");

    let resMobile;
    let resCountrycode;

    const [tohideNotification, settohideNotification] = useState(false);
    const [OtpMobilenumberGen, setOtpMobilenumberGen] = useState('');

    const [emailValue, setemailValue] = useState('');
    const [cifNum, setcifNum] = useState('');
    const [fullnameValue, setfullnameValue] = useState('');


    const [SavedInformation, setSavedInformation] = useState({
        emailAddress: "",
        idNum: "",
        idType: "",
        idIssueCountry: "",
        emailAddress: "",
        customerName: "",
        by_prdType: "",
        uniqueRequestId: ""
    });


    useEffect(() => {

        setIsLoading(true);

        if (tovalidateExpdate(new Date().getMinutes())) {
            if (configData.RefferenceNo) {
                const requestBody = {
                    //new changes passing details to save at verification
                    referenceno: configData.RefferenceNo,
                    num: localStorage.getItem('nricval')
                }

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Headers': 'Content-Type',
                        'Cache-Control': 'no-cache',//for IE issues
                        'Pragma': 'no-cache',
                        'Authorization': "Maybank" + " " + localStorage.getItem('tkn')

                    },
                    body: JSON.stringify(requestBody)
                };

                let baseUrl = configData.GET_FTDATA_PROD;

                if (configData.SERVER_STATUS === 'SIT') {
                    baseUrl = configData.GET_FTDATA_SIT;
                }
                else if (configData.SERVER_STATUS === 'UAT') {
                    baseUrl = configData.GET_FTDATA_UAT;
                }
                else {
                    baseUrl = configData.GET_FTDATA_PROD;
                }

                fetch(baseUrl, requestOptions)

                    .then(async response => {

                        setIsLoading(false);
                        const data = await response.json();
                        if (!data.didError) {
                            if (data.model.fields) {
                                setResponce(data);
                                configData.NEWReffID = data.refNo;
                                setSavedInformation(data.model);
                                window.scrollTo(0, 0);
                            }

                        } else {

                        }
                    })
                    .catch(err => {
                        console.log(err)
                        setIsLoading(false);
                        alert("This session has timed out for your security.Please try again")
                        helper.toHomeScreen();
                    })
            }
            else {
                setIsLoading(false);
                alert("This session has timed out for your security.Please try again")
                helper.toHomeScreen();
            }
        }
        else {
            setIsLoading(false);
            alert("This session has timed out for your security.");
            helper.toHomeScreen();
        }
    }, [])

    if (!response) {
        return false;
    } else {
        responsesetitesms = response.model.fields.Fields.count;
        if (response.model.fields.Fields.FT1) {

            let res = response.model.fields.Fields.FT1;
            let assaginvalueCCANo1;
            if (res.CreditAcntNO) {
                assaginvalueCCANo1 = res.CreditAcntNO;
                configData.setAcntTypename = configData.LBL_RVWLBL_CCANO;
            } else if (res.CreditAbleAcntNO) {
                assaginvalueCCANo1 = res.CreditAbleAcntNO;
                configData.setAcntTypename = configData.LBL_RVWLBL_CAANO;
            }

            if (res.CreditCardnumber) {
                try {
                    configData.decryptCA = decryptAesText(res.CreditCardnumber, key, { iv: iv });
                    configData.decryptCA = configData.decryptCA.toString(CryptoJS.enc.Utf8);
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                configData.decryptCA = res.CreditCardnumber;
            }


            if (configData.setAcntTypename) {
                try {
                    configData.decryptCA11 = decryptAesText(assaginvalueCCANo1, key, { iv: iv });
                    configData.decryptCA11 = configData.decryptCA11.toString(CryptoJS.enc.Utf8);
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                configData.decryptCA11 = assaginvalueCCANo1;
            }

            TF1FRM1 = res.transferFrom;
            CCCANO1 = configData.decryptCA11;
            Pricing1 = res.pricing;
            Trnsferto1 = res.transferto;
            NameacntHolder1 = res.Nameancnt;
            CCAnCNTNO1 = configData.decryptCA;
            AMNT1 = res.Amount;
            SourceCodehandle = res.SOURCE_CODE;

        }
    }


    const toHHMMSS = (val) => {

        var sec_num = parseInt(val / 1000, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
    };

    const updateInputValue = async (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
            await setOTPValue(e.target.value);
        }

        if (OTPValue.length === 5) {
            await setOtpconfirmDisabled(true);
        } else {
            await setOtpconfirmDisabled(false);
        }
    };

    const isNumber = async (evt) => {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;

        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            await setOTPValue("");
            await setOtpconfirmDisabled(false);
            return false;
        } else {
            await setOtpconfirmDisabled(true);
            return true;
        }
    };

    const validateForm = () => {
        let isValid = true;
        const resObj = response.model.fields.Fields.FT1;

        if (resObj.SOURCE_CODE === null || resObj.SOURCE_CODE === '' || resObj.SOURCE_CODE.length === 0) {
            isValid = false;
        }
        else if (resObj.SCHEME_CODE === 'NA' && resObj.PROMO_CODE === 'NA') {
            isValid = false;
        }

        return isValid;
    }

    const handleSubmit1 = () => {
        //OTP GENERATION START

        const responseOBJ = {};

        if (validateForm() === false) {
            alert('Some thing went wrong! please try again');
            helper.toHomeScreen();
            return;
        }

        let requestBody = {
            idNum: SavedInformation.nric,//localStorage.getItem('Otp_nric'),
            idType: SavedInformation.idType,//localStorage.getItem('Otp_idtype'),
            idIssueCountryCode: SavedInformation.idIssueCountry,//localStorage.getItem('Otp_countCode'),
            email: SavedInformation.emailAddress,//localStorage.getItem('Otp_email'),
            name: SavedInformation.customerName,//localStorage.getItem('Otp_Name'),
            by_prdType: localStorage.getItem('Otp_Prod_type'),
            uniqueRequestId: uuidv4(),//localStorage.getItem('Otp_StateIDvalue')// uuidv4()
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        };

        if (!requestBody.email) {
            requestBody.email = "";
        }


        const url = getSendOTPURL();

        fetch(url + requestBody.idNum + '/' + requestBody.idType + '/' + requestBody.idIssueCountryCode + '/' + uuidv4() + "?email=" + requestBody.email + "&name=" + requestBody.name + "&by_prodType=" + requestBody.by_prdType, requestOptions)
            .then(async response => {
                const data = await response.json();
                if (!data.didError) {
                    setIsLoading(false);
                    let res = data.model.msg;
                    let resMsgBdy = res.msgBody;
                    let resMsgHdr = res.msgHdr;
                    setALLOTPgenration(res.msgBody);

                    if (resMsgHdr.statusCode === "0") {
                        setdisabltoRequestotp(true);
                        settohideNotification(true);
                        settoshowResend(true);
                        start();
                        setIsLoading(false);
                        responseOBJ.refNo = data.refNo;

                        if (resMsgBdy.mobileNum) {
                            configData.decryptMbl = decryptAesText(resMsgBdy.mobileNum, key, { iv: iv })
                            configData.decryptMbl = configData.decryptMbl.toString(CryptoJS.enc.Utf8)

                            setOtpMobilenumberGen(configData.decryptMbl);
                            let mobiltrim = (configData.decryptMbl).substring(6);
                            settrimMobile(mobiltrim)
                        } else {
                            configData.decryptMbl = resMsgBdy.mobileNum;
                            setOtpMobilenumberGen(configData.decryptMbl);
                            settrimMobile(configData.decryptMbl);
                        }
                    } else {
                        settoshowResend(false);
                        setIsLoading(false);
                        localStorage.clear();
                        history.push("error");
                        localStorage.clear();
                    }
                } else {
                    setIsLoading(false);
                    localStorage.clear();
                    setdisabltoRequestotp(false);
                    history.push("error");
                }
            })
            .catch(error => {
                setIsLoading(false);
                // this.setState({ errorMessage: error });
                if (configData.RESEND <= 1) {
                    //alert(error);
                }
                setdisabltoRequestotp(false);
                console.error('There was an error!', error);
            });
    }

    const verifyOTPDetails = async () => {


        if (OTPValue) {
            if (!emailValue) {
                setemailValue('');
            }

            const requestBody = {
                idNum: SavedInformation.nric,//localStorage.getItem('Otp_nric'),
                idType: toFetchIDValue("IDTYPE", SavedInformation.idType,),
                idIssueCountryCode: toFetchIDValue("countries", SavedInformation.idIssueCountry),
                email: SavedInformation.emailAddress,//emailValue,
                name: SavedInformation.customerName,//fullnameValue,
                by_prdType: configData.PRODUCT_TYPE,
                cifNum: ALLOTPgenration.cifNum,// cifNum,
                otp: OTPValue,
                mobileNum: "0",//req.mobileNum ? req.mobileNum.substring(3) : '',
                accessID: "00000000",//this.state.setAccessID,
                uniqueRequestid: uuidv4(),//req.uniqueID,
                appId: '0'//configData.AUTH_CODE_Encrypt
            }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Cache-Control': 'no-cache',//for IE issues
                    'Pragma': 'no-cache',
                },
                body: JSON.stringify(requestBody)

            };

            const url = getVerifyOTPURL();

            fetch(url, requestOptions)

                .then(async response => {

                    const data = await response.json();
                    if (!data.didError) {
                        let res = data.model.msg;
                        let resMsgBdy = res.msgBody;
                        let resMsgHdr = res.msgHdr;

                        if (data.token) {
                            let tokenid = data.token;
                            let expirytoken = data.tokenExpirationDate;

                            if (resMsgBdy) {
                                localStorage.setItem("nricval", resMsgBdy.nric);
                            }
                            if (resMsgHdr.statusCode === "0") {
                                //this.props.history.push('Fundtransfer');
                                let datestr = new Date();
                                localStorage.setItem("ddt", datestr);
                                setcurrentDateTime(localStorage.getItem('ddt'));
                                settohideNotification(false);
                                SubmitFormdetails();
                            }
                            else {
                                if (resMsgHdr.statusDesc)
                                    setcount3TimeToExist(count3TimeToExist + 1)
                                if (count3TimeToExist <= 1) {
                                    alert("The OTP entered has expired/is invalid. Please re-enter the 6 Digit OTP.")
                                } else if (count3TimeToExist === 2) {
                                    alert("You have exceeded the max OTP to confirm, please try after some time");
                                    helper.toHomeScreen();
                                    return;
                                } else {
                                    alert("You have exceeded the max OTP to confirm, please try after some time");
                                    helper.toHomeScreen();
                                    return;
                                }
                            }
                        } else {
                            history.push("error");
                            localStorage.clear();
                        }
                    } else {
                        history.push("error");
                        localStorage.clear();
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });

        } else {
            await setOtpconfirmDisabled(true);
            alert("Please enter valid numeric 6 digit OTP");
        }

    }


    const SubmitFormdetails = async () => {

        //TODO OTPCHANGES
        hideContentForSubmit = true
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
            }
        };

        const url = getSubmitURL();
        fetch(url + "?refno=" + configData.RefferenceNo + "&submit=true", requestOptions)
            .then(async response => {
                const data = await response.json();
                if (data.status === "Submitted") {
                    hideContentForSubmit = true;
                    window.scrollTo(0, 0);
                    localStorage.clear();
                } else {
                    hideContentForSubmit = false;
                    alert("error");
                }
            })
            .catch(error => {
                hideContentForSubmit = false;
                console.error('There was an error!', error);
            });
    }

    const restart = () => {

        const newTime = 10 * 1000;
        start(newTime);
        setOTPValue("");
        settoshowResend(false);
        handleResendSubmit();
    }

    const handleResendSubmit = () => {
        handleSubmit1();
    };


    const termscheckoption = () => {
        setcheckedTerms(!checkedTerms);
        setdisabltoRequestotp(!disabltoRequestotp)
    }

    const toBackFTDetails = () => {
        history.push('Fundtransfer');
    }

    const toMaybankHome = () => {
        document.location.href = configData.URL_NAV_MAYBANK;
    }

    const getVerifyOTPURL = () => {
        let baseUrl = configData.URL_VERIFY_OTP_PROD;
        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_VERIFY_OTP_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_VERIFY_OTP_UAT;
        }
        else {
            baseUrl = configData.URL_VERIFY_OTP_PROD;
        }
        return baseUrl;
    }

    const getSendOTPURL = () => {
        let baseUrl = configData.URL_SEND_OTP_PROD;
        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_SEND_OTP_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_SEND_OTP_UAT;
        }
        else {
            baseUrl = configData.URL_SEND_OTP_PROD;
        }
        return baseUrl;
    }

    const getSubmitURL = () => {

        let baseUrl = configData.URL_SUBMIT_PROD;

        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_SUBMIT_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_SUBMIT_UAT;
        }
        else {
            baseUrl = configData.URL_SUBMIT_PROD;
        }
        return baseUrl;
    }


    return (
        <div className="container-fluid">
            {isLoading && <Loading />}
            <div className='row '>
                <div className="container mt-5">
                    <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
                </div>
                <FormContainer>
                    <Form
                        // onSubmit={handleSubmit1}
                        render={(formRenderProps) => (
                            <form onSubmit={formRenderProps.onSubmit} className={'k-form'}>
                                <fieldset>
                                    <br></br>
                                    <div className="row around-xs inputPairelementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            {!hideContentForSubmit && <legend>{configData.HDR_RVW_DETAILS}</legend>}
                                            {hideContentForSubmit && <legend>{configData.HDR_RVW_APPLICATION}</legend>}
                                        </div>
                                    </div>
                                    <hr className="panelLine"></hr>
                                </fieldset>

                                <fieldset>

                                    {!hideContentForSubmit && <div className="row around-xs inputPair elementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{
                                            backgroundColor: "black", color: "white", padding: "20px", borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        }}>

                                            <strong className="text-left">{configData.LBL_FT_REQUEST}</strong>
                                            <strong className="text-right" style={{ float: 'right' }} onClick={toBackFTDetails}><span style={{ cursor: "pointer" }} className="k-icon k-i-pencil"></span></strong>


                                        </div>
                                    </div>}
                                    {hideContentForSubmit && <div className="row around-xs inputPair elementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{
                                            backgroundColor: "#389a6e", color: "white", padding: "20px", borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        }}>

                                            <strong className="box text-left"><span className="k-icon k-i-check"></span><span style={{ padding: "8px" }}>Success!</span></strong>
                                        </div>

                                    </div>}

                                </fieldset>
                                {responsesetitesms >= 1 && <fieldset>

                                    <Field id={"Transfer From"} label={TF1FRM1} component={cmpnt} />
                                    <Field id={configData.setAcntTypename} label={CCCANO1} component={cmpnt} />
                                    <Field id={"Pricing"} label={Pricing1} component={cmpnt} />
                                    <Field id={"Transfer To"} label={Trnsferto1} component={cmpnt} />
                                    <Field id={"Name of Account Holder"} label={NameacntHolder1} component={cmpnt} />
                                    <Field id={"Credit Card / Account Number"} label={CCAnCNTNO1} component={cmpnt} />
                                    <Field id={"Amount"} label={AMNT1} component={cmpnt} />
                                    <hr className="panelLine"></hr>
                                </fieldset>}

                                <br></br><br></br>
                                <fieldset>
                                    {hideContentForSubmit &&

                                        <Field id={"Reference Number"} label={configData.NEWReffID} component={cmpnt} />

                                    }
                                    {hideContentForSubmit &&

                                        <Field id={"Date"} label={currentDateTime} component={cmpnt} />


                                    }
                                </fieldset>
                                
                                <div style={{textAlign: "justify"}}>
                                    <b><u>Fair Dealing</u></b> 
                                    <br></br><br></br>
                                    The Guidelines on Fair Dealing issued by the Monetary Authority of Singapore aim to promote fair dealing by financial institutions when they conduct business with their customers. At Maybank, we are fully committed to ensuring fair dealing outcomes for our customers. In providing products and services to our customers, there may be situations where we may have to exercise our right to unilaterally revise certain terms and conditions of such products or services. For more information, please refer to the Fair Dealing Disclosure Notice at maybank.sg/fairdealing.
                                </div><br></br>

                                {!hideContentForSubmit && <>
                                    {SourceCodehandle === configData.SRC_CODE_HNW ? (
                                        //  {!hideContentForSubmit &&
                                        <div>
                                            <Checkbox
                                                checked={checkedTerms}
                                                id={"declYesBOA"}
                                                disabled={checkedTerms}
                                                label={<div style={{
                                                    marginTop: "-18px",
                                                    marginLeft: "25px"
                                                }}>


                                                    <span>{LBL_TNC}</span>
                                                    <a href={urlIngersoll} target="_blank">{LBL_TNCWORD} for Maybank Funds Transfer Ingersoll Timepiece Promotion</a>
                                                    <span>  and other  </span>
                                                    <a href={url1} target="_blank">{LBL_TNCWORD}</a>
                                                    <span>  {LBL_TNCLAST}</span>


                                                </div>}
                                                onChange={termscheckoption}
                                            />
                                            {/* <span>I have read , understood and agreed to be bounded by </span>
                                                    <a href={urlGarmin} target="_blank">{LBL_TNCWORD}</a>
                                                    <span> for Maybank Funds Transfer Garmin Vivomove Timepiece Promotion and other  </span>
                                                    <a href={url1} target="_blank">{LBL_TNCWORD}</a>
                                                    <span>  {LBL_TNCLAST}</span> */}

                                            {
                                                checkedTerms === false &&
                                                <span style={{ color: "red", marginLeft: "22px" }}>{"Please accept terms & conditions of the application to proceed"}</span>
                                            }
                                        </div>
                                        // }

                                    ) :    SourceCodehandle === configData.SRC_CODE_OUTSIDERS ||  SourceCodehandle === configData.SRC_CODE_CCFT03 ? (
                                        <div>
                                        <Checkbox
                                            checked={checkedTerms}
                                            id={"declYesBOA"}
                                            disabled={checkedTerms}
                                            label={<div style={{
                                                marginTop: "-18px",
                                                marginLeft: "25px"
                                            }}>
                                                <span>{LBL_TNC}</span>
                                                <a href={urlTerms} target="_blank">{LBL_TNCWORD}</a>
                                                <span> for Maybank Funds Transfer and other  </span>
                                                <a href={url1} target="_blank">{LBL_TNCWORD}</a>
                                                <span>  {LBL_TNCLAST}</span>


                                            </div>}
                                            onChange={termscheckoption}
                                        />

                                        {
                                            checkedTerms === false &&
                                            <span style={{ color: "red", marginLeft: "22px" }}>{"Please accept terms & conditions of the application to proceed"}</span>
                                        }
                                    </div>
                                    )                    
                                    
                                    : <div>
                                        <Checkbox
                                            checked={checkedTerms}
                                            id={"declYesBOA"}
                                            disabled={checkedTerms}
                                            label={<div style={{
                                                marginTop: "-18px",
                                                marginLeft: "25px"
                                            }}>
                                                <span>{LBL_TNC}</span>                                               
                                                {SourceCodehandle === configData.SRC_CODE_CCFT04 && (
                                                    <>
                                                        <a href={urlnew} target="_blank">{LBL_TNCWORD}</a>
                                                        <span> for Maybank Funds Transfer 0.99% Processing Fee Promotion,  </span>
                                                    </>
                                                )}
                                                <a href={url} target="_blank">{LBL_TNCWORD}</a>
                                                <span> Governing Maybank Credit Card or CreditAble Funds Transfer Facility (where applicable) and other  </span>
                                                <a href={url1} target="_blank">{LBL_TNCWORD}</a>
                                                <span>  {LBL_TNCLAST}</span>


                                            </div>}
                                            onChange={termscheckoption}
                                        />

                                        {
                                            checkedTerms === false &&
                                            <span style={{ color: "red", marginLeft: "22px" }}>{"Please accept terms & conditions of the application to proceed"}</span>
                                        }
                                    </div>

                                    }
                                </>}

                                
                                <br></br><br></br>
                                {hideContentForSubmit && <b>{LBL_SUBMITTED_TEXT}</b>}
                                <br></br><br></br>
                                {!hideContentForSubmit && <div className="text-right">


                                    <Button className="btn btn-success btnMaybank" type={'submit'} style={{ padding: "13px" }}
                                        primary={true}
                                        disabled={disabltoRequestotp} onClick={handleSubmit1}>{"CONFIRM/ REQUEST OTP"} </Button>

                                </div>
                                }
                                <br></br>
                                {hideContentForSubmit && <div className="text-center">
                                    <button className="btnMaybank" type={'submit'} onClick={toMaybankHome}><span>{configData.ON_DONE}</span></button>

                                </div>}
                                <br></br><br></br>
                            </form>

                        )} />




                    {tohideNotification ? (
                        <NotificationGroup
                            style={{
                                right: 0,
                                bottom: 0,
                                alignItems: "flex-start",
                                flexWrap: "wrap-reverse",
                            }}>

                            <Notification
                                type={{ style: "warning", icon: false }}
                                closable={false} >

                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box"></div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <div
                                            className="box row"
                                            style={{
                                                textAlign: "left",
                                                color: "black",
                                                marginLeft: "10px",
                                            }} >
                                            <p> &nbsp; OTP will be sent to XXXX {trimMobile}</p>{" "}
                                            <p> &nbsp; Please confirm received OTP within 2 minutes. </p>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div
                                            className="box row"
                                            style={{
                                                textAlign: "left",
                                                color: "black",
                                                margin: "10px",
                                            }} >

                                            <div className="text-center" style={{ marginTop: "0.6rem" }} >
                                                <p data-tip="If you did not receive any, you can requestanother SMS OTP in 2:00"
                                                    className="" />
                                                {timeLeft === 0 && toshowResend ? (
                                                    <Button
                                                        className="btn btn-success btnMaybank"
                                                        style={{ padding: "10px", marginTop: "-4px" }}
                                                        primary={true}
                                                        onClick={restart}>
                                                        RESEND OTP
                                                    </Button>
                                                ) : (
                                                    <div></div>
                                                )}


                                                {toshowResend ? (
                                                    <div>
                                                        {" "}
                                                        Resend in {toHHMMSS(timeLeft)}{" "}
                                                        <span
                                                            className="k-icon k-i-clock"
                                                            style={{ marginTop: "-2px" }}
                                                        ></span>
                                                    </div>
                                                ) : (
                                                    <div></div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box">
                                            <div
                                                className="text-center"
                                                style={{ marginTop: "1.2rem" }}
                                            >
                                                <input
                                                    style={{ width: "100%" }}
                                                    onKeyPress={isNumber}
                                                    type="password"
                                                    pattern="[0-9]+"
                                                    maxLength="6"
                                                    minLength="6"
                                                    value={OTPValue}
                                                    onChange={updateInputValue}
                                                    placeholder="123456"
                                                    name=""
                                                    id="OTPValue"
                                                    className="k-textbox"
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box">
                                            <div
                                                className="text-center"
                                                style={{ marginTop: "1rem" }}
                                            >
                                                {timeLeft === 0 ? (<Button
                                                    type={"submit"}
                                                    id="docSubmit"
                                                    key="docSubmit"
                                                    primary={true}
                                                    onClick={verifyOTPDetails}
                                                    style={{ padding: "6px" }}
                                                    className="btn btn-success btnMaybank "
                                                >
                                                    {"REQUEST"}
                                                </Button>) :

                                                    (<Button
                                                        className="btn btn-success btnMaybank"
                                                        style={{ padding: "6px" }}
                                                        primary={true}
                                                        onClick={verifyOTPDetails}
                                                        disabled={!OtpconfirmDisabled}
                                                    >
                                                        CONFIRM
                                                    </Button>)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box"></div>
                                    </div>
                                </div>
                            </Notification>
                        </NotificationGroup>
                    ) : (
                        ""
                    )}
                </FormContainer>

            </div>
        </div>
    )
}

export default ReviewDetails;